// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Third Party
import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
import { Helpers } from '../../shared/services/helpers';

//Classes
import { FormAction } from "../../shared/classes/formAction";

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Bootstrap
import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Config/Globals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PurposesManagementComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector: 'purposes-management',
    template : '<div class="pm-main-div" data-test-id="content_purposes_management">\n\n    <!--=========================================================================================-->\n    <!--Upper Content Area-->\n    <!--=========================================================================================-->\n    <div class="pm-upper-div">\n\n        <!--Title-->\n        <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n        <div style="margin:0 10px 10px 20px; font-style:italic">Select an asset to view its purposes</div>\n        \n        <!--Data Controls-->\n        <div class="pm-control-div" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <div id="divRadioLabel">Filter By:</div>\n\n            <!--ALL-->\n            <div class="pm-filter-radio" (click)="_practiceFilterUpdated(\'all\')" (keyEnter)="_practiceFilterUpdated(\'all\')">\n                <input tabindex="0" id="rdoShowAll" type="radio" value="all" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowAll" class="cpd-focusable">All</label>\n            </div>\n\n            <!--ACTIVE-->\n            <div class="pm-filter-radio" (click)="_practiceFilterUpdated(\'active\')" (keyEnter)="_practiceFilterUpdated(\'active\')">\n                <input tabindex="0" id="rdoShowActive" type="radio" value="active" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowActive" class="cpd-focusable">Active</label>\n            </div>\n\n            <!--ENDED-->\n            <div class="pm-filter-radio" (click)="_practiceFilterUpdated(\'deleted\')" (keyEnter)="_practiceFilterUpdated(\'deleted\')">\n                <input tabindex="0" id="rdoShowDeleted" type="radio" value="deleted" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowDeleted" class="cpd-focusable">Ended</label>\n            </div>\n\n            <!--NATIONAL ONLY FILTERS-->\n            <!--PUBLISHED-->\n            <div *ngIf="_authToken.IsNational();" class="pm-filter-radio" (click)="_practiceFilterUpdated(\'published\')" (keyEnter)="_practiceFilterUpdated(\'published\')">\n                <input tabindex="0" id="rdoShowPublished" type="radio" value="published" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowPublished" class="cpd-focusable">Published</label>\n            </div>\n\n            <!--UN-PUBLISHED-->\n            <div *ngIf="_authToken.IsNational();" class="pm-filter-radio" (click)="_practiceFilterUpdated(\'unpublished\')" (keyEnter)="_practiceFilterUpdated(\'unpublished\')">\n                <input tabindex="0" id="rdoShowUnPublished" type="radio" value="unpublished" name="practiceFilter" [(ngModel)]="_selectedPracticeFilter" />\n                <label for="rdoShowUnPublished" class="cpd-focusable">Un-Published</label>\n            </div>\n\n            <div style="min-width:10px; min-height:20px; border-left:solid 1px #999; margin-left:10px;"></div>\n\n            <!--ASSET TYPE FILTER-->\n            <div>\n                <label for="selAssetTypeFilter" aria-label="Asset Type Filter" title="Asset Type Filter">Asset Type:</label>\n                <select id="selAssetTypeFilter" [(ngModel)]="_selectedAssetTypeFilter" (change)="assetFilterChanged($event)">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n\n\n        </div>\n\n    </div>\n\n    <!--=========================================================================================-->\n    <!--Lower Content Area-->\n    <!--=========================================================================================-->\n    <div class="pm-lower-div">\n\n        <!--Practices Grid-->\n        <cas-grid #practicesGrid\n                  summary="Asset List"\n                  [settings]="_gridSettings"\n                  (onRefreshClicked)="gridRefreshClicked()"\n                  (onSearch)="onGridSearch($event)">\n        </cas-grid>\n    </div>\n\n</div>',
    styles : ['.pm-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.pm-upper-div{flex-grow:0}.pm-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.pm-filter-radio{padding-left:10px;display:flex;align-items:center}.pm-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.pm-practicesGrid-grid{border-top:solid 1px #b8b8b8}.pm-practicesGrid-columnHeaderRow{background-color:#f0f0f0 !important}'],
    providers: []
})
export class PurposesManagementComponent implements OnDestroy, OnInit {


    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('practicesGrid') practicesGrid;

	//Class wide member reference for the growls control
	growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //Needed to use authToken on the template
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _from = null; //Holds the "from" query parameter if provided (if from==1 then this page was loaded from the initial login)

    _componentName = 'practicesView.js';

    _selectedPracticeFilter = "all";

    _assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code: "" }];
    _selectedAssetTypeFilter = this._assetTypeFilters[0];

    _now = moment();//today

    _title = "Purpose Management";

    _gridSettings = {
        //cssClasses_Grid:"pv-practicesGrid-grid",
        hideClearSelectedButton: true,
        hideSearchBox: false,
        loading: true,
        positionAbsolute: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "practice_code",
        rowIdentityPrefixForJAWS: "Asset Code",
        showCheckboxColumn: true,
        columns: [
            { fieldName: 'practice_code', display: 'Asset Code', width: '10%', minWidth: 30 },
            { fieldName: 'practice_name', display: 'Asset Name', width: '70%', minWidth: 100 },
            { fieldName: 'purpose_count', display: 'Total Purposes', width: '20%', minWidth: 40 },
        ],
        rows: []
    };


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        ngbDateParser: casNgbDateParserFormatter,
        helpers: Helpers,
        route: ActivatedRoute,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

		// Growl Prep
		//--------------------
		this.growlBox = new BCGrowls("growlBox");
		this.growlBox.init({ 
			appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
		}); 

        // Params
        //--------------------
        //Grab the "from" param if provided to alter the element focus strategy (508)
        this.route.params.subscribe((p) => {
            this._from = p.from ? p.from : null; //1==default path (i.e. initial load, not from a nav link)
            //console.log("[constructor] = this._from:", this._from);
        });

        // NavBox
        //--------------------
        //Handle clicks on the NavBox actions via the navBoxCommService
        var disposer = casNavBoxService.OnActionClicked$.subscribe(action => { this.navBoxActionClicked(action); });
        this._disposalFunctions.push(disposer);

        // Debugging 
        //--------------
        //casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("Service Test", "Test", "zRoles Test");
        //disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
        //    this._debugEntryClicked(entry);
        //});
        //this._disposalFunctions.push(disposer);
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        console.log("\n[practicesView:ngOnInit()]------------------------------------------------------------------------");
        this.set508();
        this.setNavBoxActions();
        this.performAsyncOperations();
    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {
        this._markGridAsLoading(false);
        this.casNavBoxService.ActionsLoading = false;
    };


    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {
        //console.log("[practicesView:navBoxActionClicked()] action:", action);

        switch (action.field_name.toLowerCase()) {
            // VIEW PRACTICE
            //--------------------------------------
            case "act_view_purpose":
                this.viewPurpose();
                break;
        }

    };

    //==================================
    // viewPurpose
    //==================================
    viewPurpose() {

        let selectedRow = this.practicesGrid.GetFirstSelectedRow();
            
        if (!selectedRow || !selectedRow.practice_id) {
            this.growlBox.addGrowl("info", "You must select an asset to view its purposes.");
        }
        else {
            this.router.navigate([`/cpdes/practices/purposesView/${selectedRow.practice_id}/${selectedRow.practice_state_id}`]);
        }
    }
    

    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // assetFilterChanged
    //==================================
    assetFilterChanged(e) {
        this._loadGrid(true);
    };

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        this._loadGrid(true);
    };

    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText) {

        //console.log("onGridSearch", event);

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.practicesGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.practicesGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        // Async Operations
        //-------------------
        let ops = 2;

        //LOAD GRID
        this._loadGrid(false, () => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LOAD ASSET TYPES
        this._loadAssetTypes(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });
    }

    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            //508 people want a different focus starting point if this is the first page load
            let el = null;
            if (this._from == 1) {
                el = document.getElementById("divSkipNav");
            }
            else {
                //Main content area (title)
                el = document.getElementsByClassName("cpd-title-div")[0];
            }
            if (el) { el.focus(); }

        }, 0);
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        //Mark these as loading until the grid is finished loading 
        this.casNavBoxService.ActionsLoading = true;

        //ACTIONS
        let actions = [];

        switch (this._authToken.user.role) {

            case Enums.Roles.NHQNationalPracticeDataSteward.id:
            case Enums.Roles.StateDataSteward.id:
                actions.push(new FormAction("act_view_purpose", "View Purposes"));
                break;

            case Enums.Roles.NationalDisciplineDataSteward.id:
            case Enums.Roles.DataViewer.id:
                break;
        }

        //Apply the actions        
        this.casNavBoxService.Actions = actions;
    };


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _loadAssetTypes
    //==================================
    _loadAssetTypes(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/assetTypes/getPurposeAssetTypes"})
            .then(res => {
                console.log(`[purposesManagement:/assetType/getPurposeAssetTypes] - res:`, res);
                let dto = res.data.DTO;

                //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
                try {

                    //Build the asset types list
                    this._assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code: "" }].concat(dto);
                    this._selectedAssetTypeFilter = this._assetTypeFilters[0];
                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log(`[ERROR][purposesManagement:_loadAssetTypes()]`, this.cpdFormatters.formatError(err));
                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log(`[ERROR][purposesManagement:_loadAssetTypes()]`, this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });

    }

    //==================================
    // _loadGrid
    //==================================
    // Loads the grid using the current filter
    //  Returns:Promise(recordCount)
    _loadGrid(manageLoadIndicators, fnOnSuccess, fnOnError) {

        if (manageLoadIndicators) {
            this._markGridAsLoading(true);
            this.casNavBoxService.ActionsLoading = true;
        }

        this.webServices.Get({
            apiPath: "/practices/getPracticesListByRoleV2",
            args: {
                filter: this._selectedPracticeFilter,
                assetTypeCode: this._selectedAssetTypeFilter.practice_type_code,
                filterByManagePurposes: true
            }
        })
            .then(res => {
                console.log(`[purposesManagement:/practices/getPracticesListByRoleV2] - res:`, res);
                let dto = res.data.DTO;

                //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
                try {

                    //Apply new data to the grid
                    this._setGridRows(dto);

                    //Hide the loading message
                    if (manageLoadIndicators) {
                        this._markGridAsLoading(false);
                        this.casNavBoxService.ActionsLoading = false;
                    }

                    //Fresh load, go to first page
                    this.practicesGrid.GoToFirstPage();

                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log(`[ERROR][purposesManagement:_loadGrid()]`, this.cpdFormatters.formatError(err));

                    //Always hide the loading message on errors
                    this._markGridAsLoading(false);
                    this.casNavBoxService.ActionsLoading = false;
                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log(`[ERROR][purposesManagement:_loadGrid()]`, this.cpdFormatters.formatError(err));

                //Always hide the loading message on errors
                this._markGridAsLoading(false);
                this.casNavBoxService.ActionsLoading = false;
                if (fnOnError) { fnOnError(); }
            });
    };

    

    //==================================
    // _practiceFilterUpdated
    //==================================
    _practiceFilterUpdated(filter) {

        //jump out for unrecognized filters
        if ("all,active,published,deleted,unpublished,practices,other".indexOf(filter) < 0) {
            throw ("[practicesView:_practiceFilterUpdated] Unrecognized filter");
        }

        //Set the member value
        this._selectedPracticeFilter = filter;

        //Clear any search box filters
        this.practicesGrid.ClearFilter("search", false);
        this.practicesGrid.ClearSearchBox();

        this._loadGrid(true);
    };

    // BOILER PLATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.practicesGrid) {
            this.practicesGrid.MarkAsLoading(isLoading);
        }
        else {
            this._gridSettings.loading = isLoading;
        }
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here we'll test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.practicesGrid) {
            this.practicesGrid.SetRows(data);
        }
        else {
            this._gridSettings.rows = data;
        }
    }

}//component